export default "__VITE_ASSET__7af81bd7__"